var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-grid m-grid--hor m-grid--root m-page" },
    [
      _c("header", { staticClass: "dashboard-header" }, [
        _c(
          "div",
          { staticClass: "dashboard-container" },
          [
            _c("router-link", { attrs: { to: { name: "home" } } }, [
              _c("a", { staticClass: "dashboard-logo", attrs: { href: "/" } }, [
                _c("img", {
                  attrs: {
                    src: require("../../static/styles/mailkit/img/logo2.png"),
                    alt: "CTMK"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("main-menu")
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1f1971a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f1971a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = null
// module chunks = 